import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { transformAddress } from './address';
import { transformCarrierDto } from './carrier';
import { transformPackageTypeDto } from './package-type';
import { transformShippingPointDto } from './shipping-point';
import { transformDigitalLabelTypes } from './digital-label-types';
export const transformShipmentDto = _ref => {
  let {
    id,
    price,
    status,
    carrier,
    currency,
    label_url,
    rate_uuid,
    to_address,
    from_address,
    package_type,
    pickup_point,
    tracking_code,
    digital_label_types,
    label_type
  } = _ref;
  return {
    id,
    price,
    status,
    currency,
    rateUuid: rate_uuid,
    labelUrl: label_url,
    trackingCode: tracking_code,
    carrier: transformCarrierDto(carrier),
    packageType: transformPackageTypeDto(package_type),
    toAddress: to_address && transformAddress(to_address),
    fromAddress: from_address && transformAddress(from_address),
    pickupPoint: pickup_point && transformShippingPointDto(pickup_point),
    digitalLabelTypes: digital_label_types && transformDigitalLabelTypes(digital_label_types),
    shipmentLabelType: label_type && label_type
  };
};
export const transformCheckoutShipmentDto = _ref2 => {
  let {
    id,
    price,
    status,
    carrier,
    currency,
    label_url,
    rate_uuid,
    carrier_id,
    to_address,
    entry_type,
    price_label,
    status_label,
    status_title,
    from_address,
    package_type,
    pickup_point,
    tracking_code,
    transaction_id,
    drop_off_type_id,
    status_updated_at,
    last_mile_carrier,
    first_mile_carrier,
    digital_label_types
  } = _ref2;
  return _objectSpread(_objectSpread({}, transformShipmentDto({
    id,
    price,
    status,
    carrier,
    currency,
    label_url,
    rate_uuid,
    to_address,
    from_address,
    package_type,
    pickup_point,
    tracking_code,
    digital_label_types
  })), {}, {
    carrierId: carrier_id,
    entryType: entry_type,
    priceLabel: price_label,
    statusLabel: status_label,
    statusTitle: status_title,
    transactionId: transaction_id,
    dropOffTypeId: drop_off_type_id,
    statusUpdatedAt: status_updated_at,
    lastMileCarrier: transformCarrierDto(last_mile_carrier),
    firstMileCarrier: transformCarrierDto(first_mile_carrier)
  });
};